goog.provide("shadow.js.shim.module$source$neckar_svg");
goog.provide("module$shadow_js_shim_module$source$neckar_svg");
shadow.js.shim.module$source$neckar_svg = shadow.js.nativeProvides["source/neckar.svg"] = shadow$bridge("source/neckar.svg");
module$shadow_js_shim_module$source$neckar_svg.default = shadow.js.shim.module$source$neckar_svg;
